//Styles
import 'bootstrap/dist/css/bootstrap.css';
import '@/scss/shards-dashboards.scss';
import '@/assets/scss/date-range.scss';


import 'bootstrap-css-only/css/bootstrap.min.css'
import 'primeflex/primeflex.css';
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip';
import ShardsVue from 'shards-vue'
import Vue from 'vue'
import VueRouter from "vue-router";
import Vuelidate from 'vuelidate'
//import App from './App'
import store from './store/index'
import i18n from './i18n'
//pages 
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'shards-ui/dist/css/shards.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Home from '@/views/Home.vue'
//import UserLayout from '@/layouts/Default.vue'
import UserDashboard from '@/views/UserDashboard.vue'
import Admin from '@/components/AdminDashboard.vue'
import Login from '@/components/UserLogin.vue'
import User from '@/components/registration/User';
import Contract from '@/components/registration/Contract';
import Package from '@/components/registration/Package';
import OrderService from '@/components/registration/OrderService';
import Product from '@/components/registration/Product';
import Invoice from '@/components/registration/Invoice';
import UniqueId from 'vue-unique-id';
import Device from "vue-device-detector"
//import html file
import Presentation from '@/components/Presentation'
// configure router
Vue.config.productionTip = false
Vue.use(ToastService);
Vue.use(UniqueId);
Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(ShardsVue);
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(Device)

Vue.directive('tooltip', Tooltip);


//Named route
const router = new VueRouter({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/admin',
            name: 'admin',
            component: Admin,
            children: [{
                    path: '/Invoice',
                    name: 'Invoice',
                    component: Invoice
                },
                {
                    path: '/User',
                    name: 'User',
                    component: User
                },
                {
                    path: '/Contract',
                    name: 'Contract',
                    component: Contract
                },
                {
                    path: '/Package',
                    name: 'Package',
                    component: Package
                },
                {
                    path: '/Product',
                    name: 'Product',
                    component: Product
                },
                {
                    path: '/OrderService',
                    name: 'OrderService',
                    component: OrderService
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/userDashboard',
            name: 'userDashboard',
            component: UserDashboard,

        },
        {
            path: '/presentation.html',
            name: 'presentation.html',
            component: Presentation,
        }
    ]
});


new Vue({
    i18n,
    router,
    store
}).$mount('#app')